'use strict';

export class TranslateModalProvider {
  constructor() {
    'ngInject';
  }

  preferredCustom(custom) {
    this.custom = custom;
  }

  setCustoms(customs) {
    this.customs = customs;
  }

  $get() {
    'ngInject';
    const { custom, customs } = this;

    return {
      custom,
      customs
    }
  }
}
